export function getCommerceStandaloneSearchBoxSetInitialState() {
    return {};
}
